// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:14:42.106Z
// Property: Meadow Chase (ID: 6737460151192620)
// Collections: 35 amenities, 4 floorplans (live), 27 photos, 69 POIs, 4 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192620",
  "property_external_id": "4606442",
  "property_zillow_url": "TBD",
  "property_apartments_url": "https://www.apartments.com/meadow-chase-bay-city-tx/dplcyqh",
  "property_google_business_url": "https://www.google.com/maps/place/Meadow+Chase/data=!4m2!3m1!1s0x0:0x75b67ed969cf2fe?sa=X&ved=2ahUKEwjDrZ2iw7ySAxUVlYkEHYE4AGIQ_BJ6BAgTEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321288551",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "meadow-chase",
  "property_name": "Meadow Chase",
  "property_website_url": "https://www.meadowchasebaycity.com/",
  "property_domain": "https://www.meadowchasebaycity.com/",
  "property_address": "4901 Misty Ln",
  "property_full_address": "4901 Misty Ln, Bay City, TX 77414",
  "property_address_1": "4901 Misty Ln",
  "property_address_2": null,
  "property_address_city": "Bay City",
  "property_address_state": "TX",
  "property_address_zip_full": "77414-8489",
  "property_address_zip": "77414",
  "property_address_country": "US",
  "property_address_county": "Matagorda County",
  "property_neighborhood_address": "Texas South Area",
  "property_address_latitude": "28.9530304",
  "property_address_longitude": "-95.9631017",
  "property_email": "meadowchase@rreafresidential.com",
  "property_phone": "(979) 245-8616",
  "property_call_tracking_phone": "979-432-7457",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Meadow Chase in Bay City, TX, our diverse floor plans—spacious studio, stylish one-bedroom, and comfortable two-bedroom options—cater to your lifestyle. Enjoy modern amenities like a pool, on-site management, and a business center. Ready to make a move? Check our availability or schedule a tour today!",
  "property_long_description": "**Welcome to Meadow Chase: Your Ideal Apartment Community in Bay City, TX!**\n\nDiscover the perfect blend of comfort, convenience, and style at Meadow Chase. Our thoughtfully designed floor plans include spacious one-bedroom, two-bedroom, and cozy studio options, ensuring you’ll find the perfect fit for your lifestyle. Whether you’re a busy professional, a growing family, or seeking a charming retreat, Meadow Chase has something for everyone.\n\nExperience top-notch amenities that elevate your living experience. Enjoy lounging by our inviting pool on sunny Texas afternoons, while our friendly on-site management team is always available to assist with your needs. Security is a priority here; our gated community offers peace of mind. For your convenience, we have a modern laundry facility, a fully-equipped business center for remote work or study, and flexible short-term lease options to accommodate your unique situation.\n\nAs a price leader in Bay City, TX, Meadow Chase not only provides exceptional living spaces but also exceptional value. With our competitive pricing and extensive amenities, you’ll feel right at home without breaking the bank.\n\nDon't wait to find your new home! Browse our availability today or schedule a personalized tour to experience the charm and comfort that Meadow Chase has to offer. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and a table under a teal umbrella.",
    "public_id": "019d0783-d369-75c8-a09d-943542d91fe6",
    "storage_key": "property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
    "width": 1236,
    "height": 844
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "124",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.35483870967742",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://meadowchase.loftliving.com/login",
  "property_apply_now_url": "https://8118884.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-f8e8-734b-b9be-5c0d2c354c2c.webp",
  "property_primary_logo_media": {
    "alt_text": "Meadow Chase logo with a house silhouette over hills.",
    "public_id": "019e1e05-f8e8-734b-b9be-5c0d2c354c2c",
    "storage_key": "property/6737460151192620/019e1e05-f8e8-734b-b9be-5c0d2c354c2c.webp",
    "width": 294,
    "height": 138
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-f8f3-749c-9852-d2020a0fe64e.webp",
  "property_secondary_logo_media": {
    "alt_text": "Meadow Chase logo",
    "public_id": "019e1e05-f8f3-749c-9852-d2020a0fe64e",
    "storage_key": "property/6737460151192620/019e1e05-f8f3-749c-9852-d2020a0fe64e.webp",
    "width": 294,
    "height": 138
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-f8f3-749c-9852-d2020a0fe64e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Meadow Chase logo",
    "public_id": "019e1e05-f8f3-749c-9852-d2020a0fe64e",
    "storage_key": "property/6737460151192620/019e1e05-f8f3-749c-9852-d2020a0fe64e.webp",
    "width": 294,
    "height": 138
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e8e87-3dbb-729b-b704-f980771515a8.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-3dbb-729b-b704-f980771515a8",
    "storage_key": "property/6737460151192620/019e8e87-3dbb-729b-b704-f980771515a8.webp",
    "width": 294,
    "height": 138
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "400 - 873",
  "property_sqft_min": "400",
  "property_sqft_max": "873",
  "property_price_range": "535 - 859",
  "property_price_min": "535",
  "property_price_max": "859",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/people/Meadow-Chase/61554135794659/",
  "property_instagram_url": "https://www.instagram.com/meadow_chase_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJgyJ7uN24QYYR_vKclu1nWwc",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/meadow-chase-apts-bay-city",
  "property_tiktok_url": "https://www.tiktok.com/@meadowchaseapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Meadow Chase",
  "property_home_romance_title": "Embrace Life in a Community You’ll Love Forever",
  "property_home_amenities_blurb": "<p>Experience the charm of southern living at <a href=\"/floor-plans/\">Meadow Chase Apartments</a>. Our quaint community is situated in Bay City, Texas. We’re just minutes from local eateries, shopping, and entertainment. With easy access to Highway 60, Matagorda Beach is only a short drive away. Discover a new standard of living at Meadow Chase.</p>",
  "property_home_floorplans_blurb": "<p>Located in Bay City, TX, we offer stunning <a href=\"/floor-plans/\">Studio, 1, and 2 bedroom</a> apartment homes with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Meadow Chase is more than just a place to live, it is a lifestyle.</p>",
  "property_home_gallery_blurb": "At Meadow Chase in Bay City, TX, your ideal home awaits. Choose from spacious one and two-bedroom apartments or charming studios, all featuring luxurious amenities like a shimmering pool, pet-friendly pathways, and upscale finishes. Picture yourself enjoying life in a community designed for comfort and connection—your perfect escape!",
  "property_home_neighborhood_blurb": "At Meadow Chase in Bay City, TX, your perfect home awaits among our thoughtfully designed floor plans, including cozy studios, spacious one bedrooms, and inviting two bedrooms. Embrace the vibrant neighborhood ambiance and uncover local gems just steps away. Dive into the surroundings and experience the essence of community living.",
  "property_home_reviews_blurb": "At Meadow Chase in Bay City, TX, our residents rave about the caring community and responsive management. Enjoy peace of mind in our quiet, gated environment where \"new maintenance staff are responding to service requests in a much faster time.\" Join us and see why our residents feel right at home!",
  "property_neighborhood_blurb": "<p>Located in Bay City, TX, we offer stunning <a href=\"/floor-plans/\">Studio, 1, and 2 bedroom</a> apartment homes with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Meadow Chase is more than just a place to live, it is a lifestyle.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>The comfort doesn’t end when you leave your home. Our gated community features a shimmering swimming pool, clubhouse, business center, laundry facility, and planned resident activities. We gladly welcome your four-legged friends, so be sure to bring them along. Indulge in life’s <a href=\"/gallery/\">simple pleasures at Meadow Chase</a>.</p>",
  "property_applynow_blurb": "At Meadow Chase in Bay City, TX, your perfect living space awaits—choose from a cozy studio, spacious one-bedroom, or family-friendly two-bedroom layouts. Enjoy top-notch amenities like a refreshing pool, on-site management, and a business center. Lease online today and elevate your lifestyle in this thriving community!",
  "property_contactus_blurb": "At Meadow Chase in Bay City, TX, we offer a variety of thoughtfully designed floor plans, including cozy studios, spacious one-bedroom, and versatile two-bedroom apartments. Each space is crafted for comfort and style. Have questions? Contact our leasing team today to find your perfect home!",
  "property_faqs_blurb": "At Meadow Chase in Bay City, TX, we offer a variety of thoughtfully designed floor plans, including cozy studios, spacious one-bedrooms, and accommodating two-bedrooms. Have questions about life here? Delve into our FAQs page to uncover the answers you seek about our vibrant community and its amenities.",
  "property_floorplans_blurb": "<p>Our studio, one, and two bedroom floor plans are the <a href=\"/amenities/\">ideal combination of quality and comfort</a>. Each apartment is appointed with a fully-equipped kitchen, pantry, plush carpeting, ceiling fans, and washer and dryer connections. Living space is increased with a personal balcony or patio, perfect for entertaining. Select homes feature a cozy fireplace, walk-in closets, and wood-style flooring. You’re sure to find what you’ve been looking for at Meadow Chase.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Meadow Chase in Bay City, TX, your ideal living space awaits—whether it’s a cozy studio, spacious one-bedroom, or a two-bedroom haven. With top-notch amenities like a refreshing pool and on-site management, our community is tailored for modern lifestyles. Navigate your future home using our interactive community map today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Meadow Chase in Bay City, TX, your home becomes more than just an apartment—it’s a community. With stylish one, two-bedroom, and cozy studio floor plans, you’ll find the perfect match for your lifestyle. Great friends make great neighbors, so refer a friend to join our welcoming community today!",
  "property_residentaccess_blurb": "Welcome to Meadow Chase in Bay City, TX, where comfort meets convenience. Whether you choose a cozy studio or a spacious two-bedroom apartment, our thoughtfully designed floor plans cater to your lifestyle. Residents can effortlessly manage their living experience—simply log in to pay rent, schedule maintenance, and more!",
  "property_reviews_blurb": "At Meadow Chase in Bay City, TX, residents rave about our dedicated management and prompt maintenance. As one satisfied tenant shares, \"New maintenance staff respond to service requests in a much faster time.\" Experience a peaceful, well-cared-for community where your comfort is our priority. See what our residents have to say!",
  "property_created_at": "1752257251037",
  "property_scheduletour_blurb": "At Meadow Chase in Bay City, TX, our thoughtfully designed floor plans include spacious studios, cozy one-bedroom, and inviting two-bedroom apartments. Experience the charm of our community firsthand—schedule a tour today and hear why our residents love calling Meadow Chase home!",
  "property_thankyou_blurb": "Thank you for connecting with Meadow Chase in Bay City, TX! Our diverse floor plans—ranging from cozy studios to spacious two-bedrooms—offer the perfect sanctuary to suit your lifestyle. A team member will reach out to you soon to help you find your new home sweet home.",
  "property_virtualtours_blurb": "Step into a world of comfort at Meadow Chase in Bay City, TX. Our thoughtfully designed one-bedroom, two-bedroom, and studio floor plans cater to all lifestyles. Ready to envision your new home? Experience the charm of our community – take a virtual tour today and find your perfect space!",
  "property_copyright": "2025 All Rights Reserved. Meadow Chase",
  "property_seo_title_home": "Meadow Chase | Apartments in Bay City, TX",
  "property_seo_description_home": "Welcome to Meadow Chase in Bay City, TX, where contemporary comfort meets convenience! Choose your perfect living space from our stylish studio, one, or two-bedroom floor plans. Enjoy top-notch amenities, including a refreshing pool, a welcoming business center, and responsive on-site management—all while being just steps away from your next adventure. With short-term lease options and competitive pricing, your new home awaits. Embrace a lifestyle of ease at Meadow Chase; secure your dream apartment today!",
  "property_seo_title_floorplans": "Floor Plans | studio - 2 Apartments in Bay City, TX",
  "property_seo_description_floorplans": "Unlock the door to your ideal living space at Meadow Chase in Bay City, TX. Whether you're searching for a cozy studio, a spacious one-bedroom, or a versatile two-bedroom layout, we offer a variety of thoughtfully designed floor plans to suit your lifestyle. Browse our available apartment homes and find the perfect fit that makes every day feel like a retreat.",
  "property_seo_title_amenities": "Amenities | Bay City, TX Apartments for Rent",
  "property_seo_description_amenities": "\"Elevate your lifestyle at Meadow Chase in Bay City, TX, where comfort meets convenience. Enjoy our inviting pool, modern business center, and secure gated access, all complemented by friendly on-site management. With one-bedroom, two-bedroom, and studio layouts, plus hassle-free short-term leasing options, you’ll find the perfect home tailored to your needs. Uncover the exceptional amenities that set our community apart—where every detail enhances your everyday living!\"",
  "property_seo_title_gallery": "Gallery | Apartments in Bay City, TX",
  "property_seo_description_gallery": "Capture the essence of Bay City living at Meadow Chase, where modern comfort meets vibrant community life. Browse our stunning photo gallery showcasing spacious one-bedroom, two-bedroom, and studio apartments, complemented by premium amenities like a refreshing pool, on-site management, and a convenient business center. Ready to see your future home? Picture yourself here, where short-term lease options make transitioning effortless. Explore your next chapter at Meadow Chase today!",
  "property_seo_title_virtualtours": "Virtual Tours | Meadow Chase Apartments",
  "property_seo_description_virtualtours": "Step inside the welcoming world of Meadow Chase in Bay City, TX, where comfort meets style! Browse our diverse floor plans, including cozy studios and spacious one- or two-bedroom apartments, all designed for modern living. Ready to envision your new home? Take a virtual tour of our vibrant community and rental options today!",
  "property_seo_title_interactivemap": "Interactive Map | Meadow Chase Apartments",
  "property_seo_description_interactivemap": "Nestled in the heart of Bay City, TX, Meadow Chase is your gateway to comfortable living with an array of thoughtfully designed floor plans—choose from studios, one, or two-bedroom apartments. Revel in resort-style amenities, from a sparkling pool to on-site management and a convenient laundry facility. Ready to find your perfect space? Our interactive community map allows you to browse available apartments, peek at pricing, and envision your new lifestyle. Your next home in Bay City awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Bay City, TX",
  "property_seo_description_neighborhood": "Uncover the vibrant charm of Bay City, TX, right outside your door at Meadow Chase. From cozy studio apartments to spacious one and two-bedroom layouts, your next home is nestled among local favorites and hidden gems. Take a stroll through the neighborhood and find parks, shops, and dining that perfectly fit your lifestyle. Dive into the community essence – your new adventure awaits!",
  "property_seo_title_contact": "Contact Us | Meadow Chase",
  "property_seo_description_contact": "\"Ready to find your perfect home at Meadow Chase in Bay City, TX? Whether you're seeking a cozy studio, a spacious one-bedroom, or a stylish two-bedroom apartment, our leasing team is here to help! Have questions? We're just a message away—reach out to us today!\"",
  "property_seo_title_faqs": "FAQs | Apartments in Bay City, TX",
  "property_seo_description_faqs": "Unlock the answers to your living questions at Meadow Chase in Bay City, TX! From spacious one and two-bedroom floor plans to cozy studios, our community offers a lifestyle of comfort and convenience. With premium amenities like a refreshing pool, on-site management, and a business center, everything you need is within reach. Curious about short-term leases or our gated property? Our FAQs page has the insight you’re looking for. Dive into our community details and find your perfect home today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bay City, TX",
  "property_seo_description_reviews": "\"Experience the vibrant community at Meadow Chase in Bay City, TX, where comfort meets convenience. From spacious one and two-bedroom layouts to cozy studios, our thoughtfully designed floor plans cater to every lifestyle. Enjoy top-notch amenities including a refreshing pool, on-site management, and a business center—all within a gated environment. Curious about life at Meadow Chase? Read heartfelt reviews from our residents and see why they love calling us home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Bay City, TX",
  "property_seo_description_applynow": "Unlock the door to comfort and convenience at Meadow Chase in Bay City, TX. Our thoughtfully designed one-bedroom, two-bedroom, and studio floor plans cater to every lifestyle, complemented by top-notch amenities including a refreshing pool, on-site management, and a fully-equipped business center. With short-term lease options and a commitment to affordability, your perfect home awaits. Don’t wait—secure your future at Meadow Chase; apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Meadow Chase",
  "property_seo_description_residentaccess": "\"At Meadow Chase in Bay City, TX, resident convenience is just a click away! Log in to your personalized portal to effortlessly manage rent, schedule maintenance, and unlock exclusive community updates. Your easy living experience starts here!\"",
  "property_seo_title_referafriend": "Refer A Friend | Meadow Chase",
  "property_seo_description_referafriend": "\"Invite your friends to join the vibrant community at Meadow Chase in Bay City, TX! Great friends make great neighbors—share the experience of home today and enjoy exclusive rewards for referrals. Your perfect apartment living awaits!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Meadow Chase",
  "property_seo_description_scheduletour": "\"Step into the tranquil charm of Meadow Chase in Bay City, TX, where modern living meets nature's beauty. Schedule a tour today and experience our vibrant community, spacious layouts, and unparalleled amenities that redefine apartment living.\"",
  "property_seo_title_privacy": "Privacy Policy | Meadow Chase",
  "property_seo_description_privacy": "Safeguarding your personal information is our top priority at Meadow Chase in Bay City, TX. Our privacy policy outlines how we protect your data while you enjoy a lifestyle of comfort and community. Ready to learn more? View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Meadow Chase",
  "property_seo_description_accessibility": "\"At Meadow Chase in Bay City, TX, we champion digital inclusion and accessibility for all. Our commitment ensures everyone can enjoy seamless access to our community’s resources. Learn how we create an inclusive experience designed for you.\"",
  "property_seo_title_sitemap": "Sitemap | Meadow Chase",
  "property_seo_description_sitemap": "Unravel the charm of Meadow Chase in Bay City, TX with our comprehensive sitemap. Navigate effortlessly through our vibrant community offerings, amenities, and more. Your ideal home awaits—map your journey today!",
  "property_seo_title_thankyou": "Thank You | Meadow Chase",
  "property_seo_description_thankyou": "Thank you for reaching out to Meadow Chase in Bay City, TX! Your inquiry is important to us. A friendly member of our team will be in touch soon to help you find your ideal home nestled in our vibrant community. Stay tuned for exciting updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Bay City, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293660381",
  "amenities": [
    {
      "id": "ec_0254408a6c60a3ddaa9ef9d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool with Outdoor Lounge",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85490fd57a13c6ec408a824b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Pet‑Friendly Walking Paths",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b62823823e0d74b3bfe9835",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Coffee and Tea Bar",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcb672e7b092c71958f9f5b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Exclusive Clubhouse with Business Center and Free WIFI",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ade82349e3bbb663bfcbb8b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Common Area Laundry Facility",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67326939e7acd20bccddef26",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Guest Parking Available",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36a7b9554ad6ce1c80c52419",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Controlled Access Community",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2c7cb8d81229d685ad9c1e3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df3b102e3ba495de2e0ee504",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Resident Portal",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77a03eb0a3f3899d7149f091",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74582189136c47620c6f2c7b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Flexible Rent Payment Program",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df6798dbfcdf69e204e051d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Professional On‑site Management",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a345b27286073be00caa5099",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Professional On‑site Maintenance with 24‑Hour Emergency Service",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b52785ecee698bcd02e2cd5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_675e8935587c58e86345cbf2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Flexible Leasing Terms",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0302a2c8f57eda602c7062a0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Freeways, Shopping, Public Parks, and Transportation",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06b47093704240520e2242e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Preferred Employer Program",
      "amount": "false",
      "description": "Exists exactly as listed under “COMMUNITY AMENITIES.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9fa0176e3284a87599a7fec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious Floorplans with Extra‑Large Square Footage",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_369ec0171b88716d0f63bddc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Luxury Wood‑Designed and Carpeted Flooring",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_632250e1904da21271318312",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Private Master Patios and Balconies with Additional Storage",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_514bc437b89ef871001793fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Energy‑Efficient, Modern Black Appliances*",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85622ef5e9f4e113c8d0a611",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Chef‑Ready Kitchen with Built‑In Microwave",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d3d8401bf0b5fb638f09ecb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Custom‑Feel Cabinetry with Select Upgrades*",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13e9ea57e85312a4ae75c865",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Expansive Walk‑In Closets",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc290e7f922da63b6e20118b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling fans with light kits in all bedrooms",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b73bff877d7e5becbf53125",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Modern LED Lighting*",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7018c3c665b676973f93456",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Wood‑Burning and Electric Fireplaces*",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0e988ee0b07d206fd6f10c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Garden Window*",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c0db432cd91ffe53132c3ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Connections*",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4903e39f6a9d1827937c34ec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Renovated Homes*",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b68e9804a4e1520f45e2049",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "2\" Faux Wood Blinds*",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e47650f303fee6757fff808",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Central Air and Heating",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25cd53d86ab2780a71b4160f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "High‑speed Internet Access and Cable Available",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7922f9a4a23087a6ac142c75",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Views Available",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5c0241decd1fc3fd70b91bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "Exists exactly as listed under “APARTMENT FEATURES.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_6be0fe8b-9b14-4311-b05e-3b0860d2f27a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/01a0f43d-5efb-776c-b82b-3bf9bb494d6a.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and blue umbrella.",
        "public_id": "01a0f43d-5efb-776c-b82b-3bf9bb494d6a",
        "storage_key": "property/6737460151192620/01a0f43d-5efb-776c-b82b-3bf9bb494d6a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, surrounded by comfortable lounge chairs and lush trees. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Apartment complex swimming pool with lounge chairs and blue umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2038cd25-119e-4759-87af-5a7cbd03effe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/01a0f43d-5ac2-7051-8055-2cdca6159cef.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with lounge chairs and surrounding apartment buildings on a sunny day.",
        "public_id": "01a0f43d-5ac2-7051-8055-2cdca6159cef",
        "storage_key": "property/6737460151192620/01a0f43d-5ac2-7051-8055-2cdca6159cef.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, surrounded by comfortable lounge chairs and lush trees, offering a perfect oasis for relaxation.",
      "link": "",
      "alt_text": "Sparkling swimming pool with lounge chairs and surrounding apartment buildings on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_30c407cf-85db-4d53-b4f4-28fa075434c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-153c-73d5-8f1f-3e9791f9c691.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, overhead cabinets, and a pass-through counter.",
        "public_id": "019e6100-153c-73d5-8f1f-3e9791f9c691",
        "storage_key": "property/6737460151192620/019e6100-153c-73d5-8f1f-3e9791f9c691.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Discover a functional and well-equipped kitchen featuring white appliances, ample cabinet space, and a convenient pass-through counter perfect for entertaining.",
      "link": "",
      "alt_text": "Kitchen with white appliances, overhead cabinets, and a pass-through counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0c1da53c-cbc8-4a49-89d9-9a09f1c71189",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/01a0f43d-5c8f-751a-ac30-9b32bc6b242b.webp",
      "image_media": {
        "alt_text": "Living room with a couch, two accent chairs, and a coffee table.",
        "public_id": "01a0f43d-5c8f-751a-ac30-9b32bc6b242b",
        "storage_key": "property/6737460151192620/01a0f43d-5c8f-751a-ac30-9b32bc6b242b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable couch, stylish accent chairs, and a round coffee table, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a couch, two accent chairs, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bf56b496-a536-4e69-9dbf-2fe11b0d00db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/01a0f43d-5a40-7100-851c-b729f0b274dc.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, desk with computer, and bar seating.",
        "public_id": "01a0f43d-5a40-7100-851c-b729f0b274dc",
        "storage_key": "property/6737460151192620/01a0f43d-5a40-7100-851c-b729f0b274dc.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "This spacious apartment features a comfortable living area, a dedicated workspace with a computer, and convenient bar seating, perfect for modern living.",
      "link": "",
      "alt_text": "Living room with a sofa, desk with computer, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66d87853-172a-4f4e-bd24-3f280d474b65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/01a0f43d-565e-7122-a39b-040cc058b129.webp",
      "image_media": {
        "alt_text": "Spacious living room with fireplace, TV, and seating.",
        "public_id": "01a0f43d-565e-7122-a39b-040cc058b129",
        "storage_key": "property/6737460151192620/01a0f43d-565e-7122-a39b-040cc058b129.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this stylish living room, featuring a cozy fireplace and ample seating. Perfect for unwinding or entertaining guests.",
      "link": "",
      "alt_text": "Spacious living room with fireplace, TV, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba63787d-cdee-4290-aeda-d7a565d3dde4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/01a0f43d-5a48-74fb-a59f-75c7068412ef.webp",
      "image_media": {
        "alt_text": "Modern living room with a green sofa, abstract art, and a home office setup.",
        "public_id": "01a0f43d-5a48-74fb-a59f-75c7068412ef",
        "storage_key": "property/6737460151192620/01a0f43d-5a48-74fb-a59f-75c7068412ef.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable green sofa, a striking abstract art piece, and a dedicated home office space with a desk and computer. Perfect for work and relaxation.",
      "link": "",
      "alt_text": "Modern living room with a green sofa, abstract art, and a home office setup.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_908c9df8-59ee-4dbb-bb84-84df5ff21b8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/01a0f43d-5bda-760a-806f-1033355201c2.webp",
      "image_media": {
        "alt_text": "View of apartment buildings with manicured lawns and walkways under a blue sky.",
        "public_id": "01a0f43d-5bda-760a-806f-1033355201c2",
        "storage_key": "property/6737460151192620/01a0f43d-5bda-760a-806f-1033355201c2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Experience the charm of our community, featuring well-maintained grounds, inviting walkways, and beautiful landscaping.",
      "link": "",
      "alt_text": "View of apartment buildings with manicured lawns and walkways under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_777e7727-1714-406a-974b-c475583c1a5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/01a0f43d-5dd1-753d-b4f5-518e9a9f7456.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a0f43d-5dd1-753d-b4f5-518e9a9f7456",
        "storage_key": "property/6737460151192620/01a0f43d-5dd1-753d-b4f5-518e9a9f7456.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f83fe0df-6e43-43b1-8329-45af5682f14f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/01a0f43d-5b69-7181-8816-e0429c80b7ed.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a couch, desk, and dining table.",
        "public_id": "01a0f43d-5b69-7181-8816-e0429c80b7ed",
        "storage_key": "property/6737460151192620/01a0f43d-5b69-7181-8816-e0429c80b7ed.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable couch, a functional desk space, and a large dining table perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with a couch, desk, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a63a9980-b125-43f3-bfbc-0cd618cfefcd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-1871-735b-a666-913aa486af19.webp",
      "image_media": {
        "alt_text": "Living room with a couch, dining table, and bar seating.",
        "public_id": "019e6100-1871-735b-a666-913aa486af19",
        "storage_key": "property/6737460151192620/019e6100-1871-735b-a666-913aa486af19.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, elegant dining table, and convenient bar seating, perfect for entertaining or everyday living.",
      "link": "",
      "alt_text": "Living room with a couch, dining table, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c4227905-a66f-4c69-84c0-f330093b6642",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-16ba-778f-a0fd-784d0faf8779.webp",
      "image_media": {
        "alt_text": "Bedroom with a view of the bathroom and closet.",
        "public_id": "019e6100-16ba-778f-a0fd-784d0faf8779",
        "storage_key": "property/6737460151192620/019e6100-16ba-778f-a0fd-784d0faf8779.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush carpet, a ceiling fan, and a walk-in closet. An ensuite bathroom with a shower and tub is also visible.",
      "link": "",
      "alt_text": "Bedroom with a view of the bathroom and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51dfce87-6d68-4ed9-9641-f1ae02ace2a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-1662-74ad-b34c-412bf30b9683.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, double sink, dishwasher, and refrigerator.",
        "public_id": "019e6100-1662-74ad-b34c-412bf30b9683",
        "storage_key": "property/6737460151192620/019e6100-1662-74ad-b34c-412bf30b9683.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "A functional kitchen featuring white cabinetry, a spacious double sink with a modern faucet, a dishwasher, and a refrigerator. Perfect for everyday use.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, double sink, dishwasher, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b346d72-15e3-44fe-a0d2-ce3cae76029f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-14cd-7088-bc7f-670fc0ebaa2a.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment kitchen and living area with carpet and wood-look flooring.",
        "public_id": "019e6100-14cd-7088-bc7f-670fc0ebaa2a",
        "storage_key": "property/6737460151192620/019e6100-14cd-7088-bc7f-670fc0ebaa2a.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious apartment living area flows into a functional kitchen with white appliances and ample cabinet space.",
      "link": "",
      "alt_text": "Interior view of an apartment kitchen and living area with carpet and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d7ee5fa-1c3c-460d-b538-61906491ba0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-1613-73d3-9203-7857f4e293b4.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower with white curtain.",
        "public_id": "019e6100-1613-73d3-9203-7857f4e293b4",
        "storage_key": "property/6737460151192620/019e6100-1613-73d3-9203-7857f4e293b4.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a modern vanity, toilet, and a shower/tub combo with a decorative white curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower with white curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2a0d2470-aae6-4cf8-87ea-94910a090fa3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-151e-7677-9941-cbd010f168be.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and a view into a bathroom and a closet.",
        "public_id": "019e6100-151e-7677-9941-cbd010f168be",
        "storage_key": "property/6737460151192620/019e6100-151e-7677-9941-cbd010f168be.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, plush carpeting, and convenient access to a full bathroom and a walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan and a view into a bathroom and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6a83aed-15b5-4b85-8ccd-976eeebe159c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-1308-7517-bac6-44cb3050684f.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and pass-through to kitchen",
        "public_id": "019e6100-1308-7517-bac6-44cb3050684f",
        "storage_key": "property/6737460151192620/019e6100-1308-7517-bac6-44cb3050684f.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace with tile surround and plush carpeting. Open pass-through to the kitchen area.",
      "link": "",
      "alt_text": "Living room with fireplace and pass-through to kitchen",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4d305df5-3950-48ea-a880-dfb351b1dc48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-063a-74f3-a271-ed26ba0175a9.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan, closet, and adjoining bathroom.",
        "public_id": "019e6100-063a-74f3-a271-ed26ba0175a9",
        "storage_key": "property/6737460151192620/019e6100-063a-74f3-a271-ed26ba0175a9.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, ample closet space, and convenient access to the bathroom.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan, closet, and adjoining bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_292575c6-6879-45e4-b7c6-900916f67ed3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-03f7-77cd-b928-d382ecd4c97c.webp",
      "image_media": {
        "alt_text": "View of a bathroom with a toilet, vanity, and mirror.",
        "public_id": "019e6100-03f7-77cd-b928-d382ecd4c97c",
        "storage_key": "property/6737460151192620/019e6100-03f7-77cd-b928-d382ecd4c97c.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "This bathroom features a modern vanity with ample counter space, a toilet, and a large mirror. The wood-look flooring adds a warm touch to the space.",
      "link": "",
      "alt_text": "View of a bathroom with a toilet, vanity, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c8c34bd-ecf6-4287-aca1-422d8c2183f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-02c5-76dd-a42a-7fc827b0c745.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment.",
        "public_id": "019e6100-02c5-76dd-a42a-7fc827b0c745",
        "storage_key": "property/6737460151192620/019e6100-02c5-76dd-a42a-7fc827b0c745.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious living room with a carpeted floor and an open-concept kitchen area featuring a breakfast bar.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e7105761-148d-4408-adc1-341728aafd5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-06a4-760b-bbf8-95e64ed78bbb.webp",
      "image_media": {
        "alt_text": "Kitchen area with white appliances and wooden cabinets.",
        "public_id": "019e6100-06a4-760b-bbf8-95e64ed78bbb",
        "storage_key": "property/6737460151192620/019e6100-06a4-760b-bbf8-95e64ed78bbb.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Explore this spacious kitchen featuring ample cabinet space, a full suite of white appliances, and modern wood-look flooring.",
      "link": "",
      "alt_text": "Kitchen area with white appliances and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b3cce8a-420a-48ab-8dc0-2346dd2d825b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-075d-7088-87dc-63c0ea6a1dbf.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and shower with decorative curtain.",
        "public_id": "019e6100-075d-7088-87dc-63c0ea6a1dbf",
        "storage_key": "property/6737460151192620/019e6100-075d-7088-87dc-63c0ea6a1dbf.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "A clean and well-lit bathroom featuring a vanity with a sink, a toilet with a decorative basket of toiletries, and a shower enclosed by a stylish curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, toilet, and shower with decorative curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2ec339c7-3882-47a6-9395-32ac8a9072d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-02c2-7795-a043-571ebfafead9.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white countertops, sink, dishwasher, stove, and microwave.",
        "public_id": "019e6100-02c2-7795-a043-571ebfafead9",
        "storage_key": "property/6737460151192620/019e6100-02c2-7795-a043-571ebfafead9.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "This apartment kitchen features wood cabinetry, white countertops, a double sink, dishwasher, stove, and microwave for a functional and classic design.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, white countertops, sink, dishwasher, stove, and microwave.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4130cae6-73b9-4a37-b312-420c3fae9c5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e6100-0681-7326-9b8e-3265c9b6949c.webp",
      "image_media": {
        "alt_text": "Kitchenette with white cabinets and appliances, open to a living area with carpet and sliding glass doors.",
        "public_id": "019e6100-0681-7326-9b8e-3265c9b6949c",
        "storage_key": "property/6737460151192620/019e6100-0681-7326-9b8e-3265c9b6949c.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "A bright and airy living space featuring a convenient kitchenette with ample cabinet storage and a pass-through counter, perfect for modern living.",
      "link": "",
      "alt_text": "Kitchenette with white cabinets and appliances, open to a living area with carpet and sliding glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b99a1dbc-be27-4f18-8ca0-c7d025a4eb95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e60ff-f7ae-71fe-8ab7-2b85333725ad.webp",
      "image_media": {
        "alt_text": "Empty room with neutral-colored walls and carpet flooring. Features include a ceiling light fixture and electrical outlets.",
        "public_id": "019e60ff-f7ae-71fe-8ab7-2b85333725ad",
        "storage_key": "property/6737460151192620/019e60ff-f7ae-71fe-8ab7-2b85333725ad.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "A spacious, empty room with soft carpeting and neutral walls. This versatile space is ready for your personal touch.",
      "link": "",
      "alt_text": "Empty room with neutral-colored walls and carpet flooring. Features include a ceiling light fixture and electrical outlets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bddaf9e2-77a9-4c0c-b1e9-ebd73cefe87b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e60ff-cd33-702f-8614-bf5af43ff78f.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with courtyards and landscaping.",
        "public_id": "019e60ff-cd33-702f-8614-bf5af43ff78f",
        "storage_key": "property/6737460151192620/019e60ff-cd33-702f-8614-bf5af43ff78f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover a welcoming atmosphere with beautifully maintained courtyards and lush green spaces, perfect for relaxation and outdoor enjoyment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with courtyards and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_539e6f7c-c468-4cac-a26b-78e6f12535b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e60ff-b9b4-75ba-a715-360802ccd636.webp",
      "image_media": {
        "alt_text": "Office building entrance with red brick exterior and manicured landscaping.",
        "public_id": "019e60ff-b9b4-75ba-a715-360802ccd636",
        "storage_key": "property/6737460151192620/019e60ff-b9b4-75ba-a715-360802ccd636.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to our community's leasing office, featuring a modern red brick exterior and beautiful landscaping, providing a pleasant first impression for residents and visitors.",
      "link": "",
      "alt_text": "Office building entrance with red brick exterior and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9bf358e5-cbef-4cd6-93d6-b442b12da6ac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Joe's Italian Restaurant and Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1300 7th St Suite A, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-059a-7037-b2d3-00bdf1b85878.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-059a-7037-b2d3-00bdf1b85878",
        "storage_key": "property/6737460151192620/019e1e08-059a-7037-b2d3-00bdf1b85878.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.joesbaycity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10110231498520533101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joes-italian-restaurant-and-pizza",
      "poi_latitude": "28.982655",
      "poi_longitude": "-95.9745166",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-476-3091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRd3LiDy5QYYRbRhISvvBTow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_c4b611e6-7f19-4bb2-a83e-9b1473de6992",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Fat Grass Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1717 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Storied eatery in a renovated space with exposed-brick walls & a menu of elevated American dishes.",
      "poi_long_description": "Storied eatery in a renovated space with exposed-brick walls & a menu of elevated American dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-0344-701c-b805-9f22e9d68041.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-0344-701c-b805-9f22e9d68041",
        "storage_key": "property/6737460151192620/019e1e08-0344-701c-b805-9f22e9d68041.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thefatgrass.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16821690906452366593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fat-grass-restaurant",
      "poi_latitude": "28.9833",
      "poi_longitude": "-95.96958800000002",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-244-7277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSkyhDi5QYYRARWDGMGmcuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4cc2c121-1778-4c0b-9e4e-c05841e40f89",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "K-2 Steak House",
      "poi_type": "Restaurants",
      "poi_address": "1701 8th St, Bay City, TX 77414, USA",
      "poi_short_description": "Hearty American fare served in a rustic setting with a buffalo trophy, pool table & country kitsch.",
      "poi_long_description": "Hearty American fare served in a rustic setting with a buffalo trophy, pool table & country kitsch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-870b-74c0-a313-a24cd65108b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e05-870b-74c0-a313-a24cd65108b1",
        "storage_key": "property/6737460151192620/019e1e05-870b-74c0-a313-a24cd65108b1.webp",
        "width": 1018,
        "height": 1280
      },
      "poi_business_url": "http://www.k2steakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=702108447398360416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "k-2-steak-house",
      "poi_latitude": "28.984292",
      "poi_longitude": "-95.969771",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-245-6936",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0cKGgke5QYYRYPX6uOljvgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_eafee117-7e28-45dc-adf6-8516c6acac4c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Bay City Seafood",
      "poi_type": "Restaurants",
      "poi_address": "3729 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Casual eatery offering seafood, plus burgers and alligator tails, in a kid-friendly atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-010f-71de-bacb-d5d266e4721f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-010f-71de-bacb-d5d266e4721f",
        "storage_key": "property/6737460151192620/019e1e08-010f-71de-bacb-d5d266e4721f.webp",
        "width": 960,
        "height": 957
      },
      "poi_business_url": "https://online.skytab.com/s/baycityseafood",
      "poi_directions_map_url": "https://maps.google.com/?cid=4129250672631868337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-city-seafood",
      "poi_latitude": "28.9832717",
      "poi_longitude": "-95.9451015",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-244-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdXlXngy5QYYRsevD6psLTjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_41740211-1133-46d2-b7f6-ac890c7fbcb9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "A & A Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "3404 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Drive-thru eatery dishing up Texan-style barbecued meats and sides such as brisket and sausage.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-01c4-76d2-8319-a62f659dd17d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-01c4-76d2-8319-a62f659dd17d",
        "storage_key": "property/6737460151192620/019e1e08-01c4-76d2-8319-a62f659dd17d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://a-a-bar-b-que.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12647876840959968100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a--a-bar-b-que",
      "poi_latitude": "28.9828742",
      "poi_longitude": "-95.9496613",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-244-5186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB3cIPg25QYYRZANPvPlIhq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b4ae3bb6-2f9d-4300-a7fe-0268a2956097",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Lambo Wok",
      "poi_type": "Restaurants",
      "poi_address": "3201 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Casual eatery with a drive through offering Chinese comfort food including vegan options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-02d9-73a7-9b55-d9e152600edc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-02d9-73a7-9b55-d9e152600edc",
        "storage_key": "property/6737460151192620/019e1e08-02d9-73a7-9b55-d9e152600edc.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=605078164035024513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lambo-wok",
      "poi_latitude": "28.983576",
      "poi_longitude": "-95.951782",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-245-3323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJISFPpBK5QYYRgTanZGKrZQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_0a22313d-5cd2-4ecc-8fe7-798c0a0cbe2d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Yamato Hibachi & Sushi",
      "poi_type": "Restaurants",
      "poi_address": "4500 7th St #200, Bay City, TX 77414, USA",
      "poi_short_description": "Casual sushi spot with hibachi dishes, bento boxes and other Japanese fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-0215-76ae-9927-1d4ff57ff691.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-0215-76ae-9927-1d4ff57ff691",
        "storage_key": "property/6737460151192620/019e1e08-0215-76ae-9927-1d4ff57ff691.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://yamatobaycity.kwickmenu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=403614559209512833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yamato-hibachi--sushi",
      "poi_latitude": "28.9842536",
      "poi_longitude": "-95.9367196",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 979-476-3143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn0LRbfG5QYYRgd_bm03tmQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_62dff662-651d-44ef-a242-9154aa50a12e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "5512 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-7cca-763c-b78a-4a062f7b4e92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e05-7cca-763c-b78a-4a062f7b4e92",
        "storage_key": "property/6737460151192620/019e1e05-7cca-763c-b78a-4a062f7b4e92.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/bay-city-tx?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15346093258462430392&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "28.9893707",
      "poi_longitude": "-95.9279154",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 979-476-5926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIfQLUnu5QYYRuISr8IJG-NQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_55d45a63-d0bd-4292-8ab1-58efe8b5de9f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "4207 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-05bc-767d-835f-1e715e3411b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-05bc-767d-835f-1e715e3411b3",
        "storage_key": "property/6737460151192620/019e1e08-05bc-767d-835f-1e715e3411b3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chilis.com/locations/us/texas/bay-city/bay-city?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=14280466161115129833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "28.983708",
      "poi_longitude": "-95.939648",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-244-2144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWH0FaC5QYYR6edA-E9oLsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_00a3e1e1-c975-4890-b422-cb10f193bdfe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "La Casona Dining & Bar",
      "poi_type": "Restaurants",
      "poi_address": "2416 Avenue F, Bay City, TX 77414, USA",
      "poi_short_description": "Unpretentious eatery serving familiar Tex-Mex cuisine such as fajitas & enchiladas, plus cocktails.",
      "poi_long_description": "Unpretentious eatery serving familiar Tex-Mex cuisine such as fajitas & enchiladas, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-8126-725c-887a-07d36ffcaa01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e05-8126-725c-887a-07d36ffcaa01",
        "storage_key": "property/6737460151192620/019e1e05-8126-725c-887a-07d36ffcaa01.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://lacasonatexmexcantina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12042981497055236036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-casona-dining--bar",
      "poi_latitude": "28.9789541",
      "poi_longitude": "-95.9702153",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-245-2449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSS34njm5QYYRxE-UeN1DIac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_fdb591dd-d4a2-4383-9118-c78dd89e2442",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Blue Ocean Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2921 Avenue F, Bay City, TX 77414, USA",
      "poi_short_description": "Fried fish, stuffed shrimp baskets, and other seafood specialties offered in a casual venue.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-091a-74fe-8d1a-e7de0fbc2539.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-091a-74fe-8d1a-e7de0fbc2539",
        "storage_key": "property/6737460151192620/019e1e08-091a-74fe-8d1a-e7de0fbc2539.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/blueoseafood",
      "poi_directions_map_url": "https://maps.google.com/?cid=8522722753166050919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-ocean-restaurant",
      "poi_latitude": "28.9734848",
      "poi_longitude": "-95.969362",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 979-245-6559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5aoJQvu7QYYRZwaaTTDLRnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_bfe81880-c54a-49b3-9b89-ea49e17f6795",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "The Farmhouse Cafe' & Mercantile",
      "poi_type": "Restaurants",
      "poi_address": "2125 Avenue G, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-060b-7388-9cf5-d4a3584c42b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-060b-7388-9cf5-d4a3584c42b0",
        "storage_key": "property/6737460151192620/019e1e08-060b-7388-9cf5-d4a3584c42b0.webp",
        "width": 1097,
        "height": 477
      },
      "poi_business_url": "https://www.thefarmhousecafetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5391780699789625108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-farmhouse-cafe--mercantile",
      "poi_latitude": "28.9823641",
      "poi_longitude": "-95.9686525",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-245-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBW1GeWq5QYYRFIfExfpz00o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_99e5a221-389f-48ad-bc77-d87452ee5aef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Billy's Grille & Bar",
      "poi_type": "Restaurants",
      "poi_address": "6655 7th St Suite 100, Bay City, TX 77414, USA",
      "poi_short_description": "Cozy restaurant serving quick bites, beer, and cocktails in an environment with TV sports.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-0f69-765c-8fc3-934f27a11e85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-0f69-765c-8fc3-934f27a11e85",
        "storage_key": "property/6737460151192620/019e1e08-0f69-765c-8fc3-934f27a11e85.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://billysgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18190456978370311553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "billys-grille--bar",
      "poi_latitude": "28.9990171",
      "poi_longitude": "-95.9168733",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 979-429-2612",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwcehlte5QYYRgbXJoT58cfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_febc92c4-9aa3-4c74-b31a-067d6cbbbe90",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "El Zarape",
      "poi_type": "Restaurants",
      "poi_address": "1917 13th St, Bay City, TX 77414, USA",
      "poi_short_description": "Family-friendly, long-lasting eatery serving fajitas and other classic dishes of Tex-Mex origin.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-0cbb-704f-bff2-8d79625ad1d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-0cbb-704f-bff2-8d79625ad1d6",
        "storage_key": "property/6737460151192620/019e1e08-0cbb-704f-bff2-8d79625ad1d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8593143957557587737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-zarape",
      "poi_latitude": "28.9897892",
      "poi_longitude": "-95.9669424",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-245-2097",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c01f-75a5-8157-1869c3d068fa",
        "storage_key": "property/6737460151192620/019e1e05-c01f-75a5-8157-1869c3d068fa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8-RTiC5QYYRGa8Dpub6QHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_8294afe6-6063-455f-bd67-bc738afb4e02",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-7f0d-772c-9cee-c49da389e72f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e05-7f0d-772c-9cee-c49da389e72f",
        "storage_key": "property/6737460151192620/019e1e05-7f0d-772c-9cee-c49da389e72f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/bay-city/bay-city-h-e-b-292?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=5337264865892945535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "28.9825944",
      "poi_longitude": "-95.9578429",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-245-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00e-74d3-afad-75e4b7189ebf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00e-74d3-afad-75e4b7189ebf",
        "storage_key": "property/6737460151192620/019e1e05-c00e-74d3-afad-75e4b7189ebf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9R8EuBS5QYYRf864Ex7GEUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_50d7af10-ce73-4ddf-b9d3-5eb953a08557",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4600 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Clean department store featuring groceries, home goods and furniture.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-0f00-72bd-b235-9048703234d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-0f00-72bd-b235-9048703234d3",
        "storage_key": "property/6737460151192620/019e1e08-0f00-72bd-b235-9048703234d3.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1405-bay-city-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=434503120913502825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "28.9840087",
      "poi_longitude": "-95.9345626",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 979-245-0196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00d-76bf-864e-0b5380b5bae5",
        "storage_key": "property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMZaf05m5QYYRaRLZT0mqBwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_e3804f5b-bd5d-4597-a0fc-22394f44eaa5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "3018 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-108d-72a1-b2e3-ae0e67e562b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-108d-72a1-b2e3-ae0e67e562b5",
        "storage_key": "property/6737460151192620/019e1e08-108d-72a1-b2e3-ae0e67e562b5.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3018+7th+st-bay+city-tx-77414/id=9440",
      "poi_directions_map_url": "https://maps.google.com/?cid=14952278572049448631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "28.9827987",
      "poi_longitude": "-95.9536843",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-323-7862",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1uTJxO5QYYRtz6xBSQqgc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_83f448e8-c714-405e-a617-08b017466145",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Stripes",
      "poi_type": "Shopping & Retail",
      "poi_address": "5620 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Convenience store chain with made-to-order & prepared snacks, coffee, cold drinks & sundries.",
      "poi_long_description": "Convenience store chain with made-to-order & prepared snacks, coffee, cold drinks & sundries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-122e-76c6-b109-e468106e3dc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-122e-76c6-b109-e468106e3dc3",
        "storage_key": "property/6737460151192620/019e1e08-122e-76c6-b109-e468106e3dc3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.stripesstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16090310752610598661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stripes",
      "poi_latitude": "28.9906081",
      "poi_longitude": "-95.9256552",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 979-244-4737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b22-75ac-8509-ba6d3e88b128.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b22-75ac-8509-ba6d3e88b128",
        "storage_key": "property/6737460151192620/019e1e08-4b22-75ac-8509-ba6d3e88b128.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJee0e75O5QYYRBb8AH2FETN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_8162a255-067a-4534-9d3f-69660542a764",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "3104 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-11ab-73b5-9959-115c823f349d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-11ab-73b5-9959-115c823f349d",
        "storage_key": "property/6737460151192620/019e1e08-11ab-73b5-9959-115c823f349d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/tx/bay-city/3104-7th-street?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11135417933817018313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "28.982634",
      "poi_longitude": "-95.9524346",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-323-6120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00d-76bf-864e-0b5380b5bae5",
        "storage_key": "property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJC9lfuBK5QYYRyXet4pzziJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_0140bc54-889b-4081-a34d-9632820338bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "2917 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-13d0-77cb-855a-65c938a0c2f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-13d0-77cb-855a-65c938a0c2f1",
        "storage_key": "property/6737460151192620/019e1e08-13d0-77cb-855a-65c938a0c2f1.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://locations.familydollar.com/tx/bay-city/2917-7th-st?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13222299502640140380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "28.9840309",
      "poi_longitude": "-95.9550467",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-323-6206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00d-76bf-864e-0b5380b5bae5",
        "storage_key": "property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBYH9ORO5QYYRXJCwyFcLf7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_fefd0c8f-995d-4e54-bb9e-32b04d68a6df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Rack Room Shoes",
      "poi_type": "Shopping & Retail",
      "poi_address": "4012 7th St Hwy 35, Bay City, TX 77414, USA",
      "poi_short_description": "Footwear chain stocking a wide range of brand-name shoes for men, women & kids, plus accessories.",
      "poi_long_description": "Footwear chain stocking a wide range of brand-name shoes for men, women & kids, plus accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-1677-74af-9bfe-0d1f85fa7f9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-1677-74af-9bfe-0d1f85fa7f9d",
        "storage_key": "property/6737460151192620/019e1e08-1677-74af-9bfe-0d1f85fa7f9d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.rackroomshoes.com/store/1068?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=1068",
      "poi_directions_map_url": "https://maps.google.com/?cid=2893022422602439958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rack-room-shoes",
      "poi_latitude": "28.9840545",
      "poi_longitude": "-95.9428889",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 979-313-5456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00d-76bf-864e-0b5380b5bae5",
        "storage_key": "property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcSTc0X-5QYYRFl11wpAUJig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "custom_23c7ec58-3d37-45ef-af42-d3afde38d703",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Ace Hardware",
      "poi_type": "Shopping & Retail",
      "poi_address": "4127 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-1621-76fc-896e-6dc72e4c7a67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-1621-76fc-896e-6dc72e4c7a67",
        "storage_key": "property/6737460151192620/019e1e08-1621-76fc-896e-6dc72e4c7a67.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mycoastalace.com/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=16909",
      "poi_directions_map_url": "https://maps.google.com/?cid=7755573762981930413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ace-hardware",
      "poi_latitude": "28.9830723",
      "poi_longitude": "-95.9416546",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-330-5055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00d-76bf-864e-0b5380b5bae5",
        "storage_key": "property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzZseS1C3QYYRraXgIz9VoWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_9e69858d-b700-48b4-bc1f-ae9ea74ed1c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "The Burlap Sack Boutique",
      "poi_type": "Shopping & Retail",
      "poi_address": "2105 Avenue G, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-16dc-70e3-867f-24a828651b48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-16dc-70e3-867f-24a828651b48",
        "storage_key": "property/6737460151192620/019e1e08-16dc-70e3-867f-24a828651b48.webp",
        "width": 1280,
        "height": 1027
      },
      "poi_business_url": "http://theburlapsack.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11832277687553131388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-burlap-sack-boutique",
      "poi_latitude": "28.982825",
      "poi_longitude": "-95.9685542",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-479-4433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00d-76bf-864e-0b5380b5bae5",
        "storage_key": "property/6737460151192620/019e1e05-c00d-76bf-864e-0b5380b5bae5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQekimDi5QYYRfINi4t2xNKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "womens_clothing_store"
    },
    {
      "id": "custom_22147786-56f8-4029-a8c3-1a9ef25e3b79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Bay City High School",
      "poi_type": "Education",
      "poi_address": "400 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-179f-702a-82f5-26ee2dc24bd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-179f-702a-82f5-26ee2dc24bd4",
        "storage_key": "property/6737460151192620/019e1e08-179f-702a-82f5-26ee2dc24bd4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://bchs.bcblackcats.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7809571903998314234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-city-high-school",
      "poi_latitude": "28.9812431",
      "poi_longitude": "-95.9853263",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-401-1101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c05b-706c-bb88-93fb51799d47",
        "storage_key": "property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH6bSYDW5QYYR-sawEUUsYWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_848b65a4-ad89-468c-b3ed-ee865bd60e66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Bay City Junior High School",
      "poi_type": "Education",
      "poi_address": "3010 Carey Smith Blvd, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-1dcc-727b-a2e4-130ce9084221.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-1dcc-727b-a2e4-130ce9084221",
        "storage_key": "property/6737460151192620/019e1e08-1dcc-727b-a2e4-130ce9084221.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "https://bcjh.bcblackcats.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1861659372196750979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-city-junior-high-school",
      "poi_latitude": "28.990228",
      "poi_longitude": "-95.9556926",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 979-401-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c05b-706c-bb88-93fb51799d47",
        "storage_key": "property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz9W6_mu5QYYRg2aQ5FXx1Rk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1fce933b-96ca-4072-9e1b-3730778b86a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Cherry Elementary School",
      "poi_type": "Education",
      "poi_address": "2619 8th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-1b37-7384-9825-7a44898a99bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-1b37-7384-9825-7a44898a99bc",
        "storage_key": "property/6737460151192620/019e1e08-1b37-7384-9825-7a44898a99bc.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://jhc.bcblackcats.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9229603757289035644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cherry-elementary-school",
      "poi_latitude": "28.9848711",
      "poi_longitude": "-95.9586459",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-401-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c05b-706c-bb88-93fb51799d47",
        "storage_key": "property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4fiYzmq5QYYRfNfSercjFoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_aa8f8ea7-c63d-4b8a-9c3c-197185b7aa72",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Linnie Roberts Elementary School",
      "poi_type": "Education",
      "poi_address": "4100 Hiram Brandon Dr, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-1b2c-73c1-b21d-f2b6ab0d4330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-1b2c-73c1-b21d-f2b6ab0d4330",
        "storage_key": "property/6737460151192620/019e1e08-1b2c-73c1-b21d-f2b6ab0d4330.webp",
        "width": 1280,
        "height": 448
      },
      "poi_business_url": "https://lre.bcblackcats.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2708950012497892692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "linnie-roberts-elementary-school",
      "poi_latitude": "28.9608572",
      "poi_longitude": "-95.9726006",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 979-401-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c05b-706c-bb88-93fb51799d47",
        "storage_key": "property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR8xJDyW5QYYRVBU6Ca8fmCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4cdc3c3d-fdc2-4fad-a293-652cb5129176",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Tenie Holmes Elementary School",
      "poi_type": "Education",
      "poi_address": "3200 5th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-2061-7480-b168-de08a3baa1d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-2061-7480-b168-de08a3baa1d0",
        "storage_key": "property/6737460151192620/019e1e08-2061-7480-b168-de08a3baa1d0.webp",
        "width": 626,
        "height": 624
      },
      "poi_business_url": "https://the.bcblackcats.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15050081037543661511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tenie-holmes-elementary-school",
      "poi_latitude": "28.9802413",
      "poi_longitude": "-95.9516167",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-401-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c05b-706c-bb88-93fb51799d47",
        "storage_key": "property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnSvgYhK5QYYRx9-hA_eg3NA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_18f170eb-1d96-4936-a757-2745660a8700",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "iCreate Child Development Center",
      "poi_type": "Education",
      "poi_address": "1901 Golden Ave, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8419692071716469472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "icreate-child-development-center",
      "poi_latitude": "28.9959141",
      "poi_longitude": "-95.9677684",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-429-2555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c05b-706c-bb88-93fb51799d47",
        "storage_key": "property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJydo7Zti5QYYR4DrVbFTB2HQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_eb4ca076-ab04-430c-b9b5-6ef971cba1eb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Bay City Kids Academy",
      "poi_type": "Education",
      "poi_address": "3305 Avenue F, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-21a9-73fd-8f39-35e3f79bba22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-21a9-73fd-8f39-35e3f79bba22",
        "storage_key": "property/6737460151192620/019e1e08-21a9-73fd-8f39-35e3f79bba22.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://baycitykidstx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13584087954125451774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-city-kids-academy",
      "poi_latitude": "28.9699645",
      "poi_longitude": "-95.9687537",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 979-393-0022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c05b-706c-bb88-93fb51799d47",
        "storage_key": "property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzWZL7CS5QYYR_nFPzwVghLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f86a9255-2a9f-49e5-92e7-88bd068b5c28",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "\"Enriching Minds One At A Time\"",
      "poi_type": "Education",
      "poi_address": "4311 Avenue F, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-2346-7134-abb7-28229cf92821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-2346-7134-abb7-28229cf92821",
        "storage_key": "property/6737460151192620/019e1e08-2346-7134-abb7-28229cf92821.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://discoveringmindscdc.com/contact",
      "poi_directions_map_url": "https://maps.google.com/?cid=12255895250106510506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enriching-minds-one-at-a-time",
      "poi_latitude": "28.9591099",
      "poi_longitude": "-95.969016",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 979-476-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c05b-706c-bb88-93fb51799d47",
        "storage_key": "property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu1HtuNi4QYYRquz-osuvFao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_24c705bd-1893-4796-8f84-a46fe7e4b4a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Upbring Bay City Head Start",
      "poi_type": "Education",
      "poi_address": "3008 Letulle Ave, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-93ca-74af-925d-d9ad839a5c6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e05-93ca-74af-925d-d9ad839a5c6b",
        "storage_key": "property/6737460151192620/019e1e05-93ca-74af-925d-d9ad839a5c6b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.upbring.org/programs-and-services/education/head-start/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11567261084522652992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upbring-bay-city-head-start",
      "poi_latitude": "28.9721387",
      "poi_longitude": "-95.9811413",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-320-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c05b-706c-bb88-93fb51799d47",
        "storage_key": "property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP6-K1uG5QYYRQCUsn6sqh6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c9f4ec25-0ebb-4fea-a823-021236f3e112",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Schulman's Movie Bowl Grille - Bay City",
      "poi_type": "Entertainment",
      "poi_address": "6655 7th St Suite 100, Bay City, TX 77414, USA",
      "poi_short_description": "Relaxed entertainment center featuring a movie theater with reclining seats and in-theater dining.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-2481-70d8-ae3f-7b276218ed97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-2481-70d8-ae3f-7b276218ed97",
        "storage_key": "property/6737460151192620/019e1e08-2481-70d8-ae3f-7b276218ed97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.moviebowlgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2570191481693140672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schulmans-movie-bowl-grille---bay-city",
      "poi_latitude": "28.999209",
      "poi_longitude": "-95.9169357",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 979-429-2610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b4b-7148-92d9-a4a0212c8e18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b4b-7148-92d9-a4a0212c8e18",
        "storage_key": "property/6737460151192620/019e1e08-4b4b-7148-92d9-a4a0212c8e18.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJiTuWdvK5QYYRwPYN_4gnqyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_6644f893-f5cf-49ef-a0b5-48a70c0f9be4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Matagorda County Museum",
      "poi_type": "Entertainment",
      "poi_address": "2100 Avenue F, Bay City, TX 77414, USA",
      "poi_short_description": "Museum where kids can interact with hands-on displays while learning about local history.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-906d-77ea-b284-b2dc060df8c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e05-906d-77ea-b284-b2dc060df8c8",
        "storage_key": "property/6737460151192620/019e1e05-906d-77ea-b284-b2dc060df8c8.webp",
        "width": 1280,
        "height": 859
      },
      "poi_business_url": "https://matagordacounty-museum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13116037061052106112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matagorda-county-museum",
      "poi_latitude": "28.9826915",
      "poi_longitude": "-95.9704432",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-245-7502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c06d-732d-8e83-872c015604a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c06d-732d-8e83-872c015604a8",
        "storage_key": "property/6737460151192620/019e1e05-c06d-732d-8e83-872c015604a8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJGdGBhzi5QYYRgIXeHDeGBbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a18cd3d2-bc84-4848-a506-da5150c6718b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Bay City Civic Center",
      "poi_type": "Entertainment",
      "poi_address": "201 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-240b-757a-b2f3-2a87c588c459.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-240b-757a-b2f3-2a87c588c459",
        "storage_key": "property/6737460151192620/019e1e08-240b-757a-b2f3-2a87c588c459.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2723340523406833898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-city-civic-center",
      "poi_latitude": "28.98327119999999",
      "poi_longitude": "-95.9879253",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 979-245-8333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDA-rW-QYYR6jgX9MY_yyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_5505f1e7-e4fc-463a-8d1f-db2704055d86",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Mainstreet Coffee & Wine Bar",
      "poi_type": "Entertainment",
      "poi_address": "1822 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Chill cafe featuring high-quality coffee and teas, plus pastries and gourmet salads.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-078d-708b-be50-067dea6ad992.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-078d-708b-be50-067dea6ad992",
        "storage_key": "property/6737460151192620/019e1e08-078d-708b-be50-067dea6ad992.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mainstreetcoffeebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=54856396783315171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mainstreet-coffee--wine-bar",
      "poi_latitude": "28.98289939999999",
      "poi_longitude": "-95.9680723",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-245-4105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b1d-737a-9f58-c75855a71dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b1d-737a-9f58-c75855a71dad",
        "storage_key": "property/6737460151192620/019e1e08-4b1d-737a-9f58-c75855a71dad.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJB4A1pTi5QYYR42jtK5rjwgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_b677aa63-a0b4-41f0-b276-137acce68d1e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Neon Moon",
      "poi_type": "Entertainment",
      "poi_address": "5212 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Casual hangout featuring live bands and karaoke, plus pool tables and bar games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-2626-77cf-864a-459d43628f4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-2626-77cf-864a-459d43628f4e",
        "storage_key": "property/6737460151192620/019e1e08-2626-77cf-864a-459d43628f4e.webp",
        "width": 960,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9552687122350510288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neon-moon",
      "poi_latitude": "28.9888381",
      "poi_longitude": "-95.929161",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 979-245-5566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b21-7489-a3ac-ad5ed4e09f32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b21-7489-a3ac-ad5ed4e09f32",
        "storage_key": "property/6737460151192620/019e1e08-4b21-7489-a3ac-ad5ed4e09f32.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH3Dw75O5QYYR0JAmUlP2kYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_f832d2c6-cd1c-44cc-8f07-07a392109d61",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Sea Center Texas",
      "poi_type": "Entertainment",
      "poi_address": "302 Medical Dr, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Marine museum with touch tanks, an aquarium, a hatchery & outdoor wetlands with a boardwalk trail.",
      "poi_long_description": "Marine museum with touch tanks, an aquarium, a hatchery & outdoor wetlands with a boardwalk trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-29ff-755d-af53-2b61eb403e95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-29ff-755d-af53-2b61eb403e95",
        "storage_key": "property/6737460151192620/019e1e08-29ff-755d-af53-2b61eb403e95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tpwd.state.tx.us/spdest/visitorcenters/seacenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5300814108973983062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-center-texas",
      "poi_latitude": "29.01748",
      "poi_longitude": "-95.4459616",
      "poi_miles_from_property": "42.7",
      "poi_walking_minutes": "15 hours 29 mins",
      "poi_biking_minutes": "3 hours 37 mins",
      "poi_driving_minutes": "52 mins",
      "poi_business_phone": "+1 979-292-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ3BssNhDQIYRVuXF4VhGkEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_d838bef1-531e-404d-b682-3bda986f55e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "MMG Walk-In Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "600 Hospital Cir Ste. 102, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-2f02-709f-95c7-901a73770809.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-2f02-709f-95c7-901a73770809",
        "storage_key": "property/6737460151192620/019e1e08-2f02-709f-95c7-901a73770809.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.matagordamedical.com/walk-in-clinic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6877663701023907083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mmg-walk-in-clinic",
      "poi_latitude": "28.9813044",
      "poi_longitude": "-95.99283210000002",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 979-241-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7bEAeS_QYYRC90gWLJecl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f999f066-f70d-4592-8f45-afaaf6782078",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "MRMC Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "135 Medical Center Dr, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-2f26-7021-ab7b-2c0ee77f5b79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-2f26-7021-ab7b-2c0ee77f5b79",
        "storage_key": "property/6737460151192620/019e1e08-2f26-7021-ab7b-2c0ee77f5b79.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.matagordaregional.org/wellness",
      "poi_directions_map_url": "https://maps.google.com/?cid=14928183677472938230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mrmc-wellness",
      "poi_latitude": "28.981254",
      "poi_longitude": "-95.993733",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-241-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7dvk2a_QYYR9hiPNfaPK88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_06695814-a879-4e09-91bc-93a4e1043d7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2711 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-0e5c-754d-acb3-f03ca8e6e65e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-0e5c-754d-acb3-f03ca8e6e65e",
        "storage_key": "property/6737460151192620/019e1e08-0e5c-754d-acb3-f03ca8e6e65e.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/bay-city-tx-pharmacies/2711-7th-st-bay-city-tx-77414/storeid=6723?WT.mc_id=LS_GOOGLE_RX_6723",
      "poi_directions_map_url": "https://maps.google.com/?cid=8101489429692660670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "28.9838136",
      "poi_longitude": "-95.9576127",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-245-1657",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b22-75ac-8509-be89e9a7a52e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b22-75ac-8509-be89e9a7a52e",
        "storage_key": "property/6737460151192620/019e1e08-4b22-75ac-8509-be89e9a7a52e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEen9shS5QYYRvrtpeLZFbnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_186647bd-583e-4635-af8d-714514b7fefa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-3042-74f9-8a24-3e5d15826758.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-3042-74f9-8a24-3e5d15826758",
        "storage_key": "property/6737460151192620/019e1e08-3042-74f9-8a24-3e5d15826758.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=4057043800420163969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "28.9829285",
      "poi_longitude": "-95.9578329",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-245-1881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b22-75ac-8509-be89e9a7a52e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b22-75ac-8509-be89e9a7a52e",
        "storage_key": "property/6737460151192620/019e1e08-4b22-75ac-8509-be89e9a7a52e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9R8EuBS5QYYRgaE-YteDTTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_0f126294-26df-40b1-ad11-ada7f11ed4a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3018 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-3311-7458-80e8-864d0ac35b10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-3311-7458-80e8-864d0ac35b10",
        "storage_key": "property/6737460151192620/019e1e08-3311-7458-80e8-864d0ac35b10.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3018+7th+st-bay+city-tx-77414/id=9440",
      "poi_directions_map_url": "https://maps.google.com/?cid=2327463875624475776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "28.9827553",
      "poi_longitude": "-95.953702",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-323-7862",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b22-75ac-8509-be89e9a7a52e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b22-75ac-8509-be89e9a7a52e",
        "storage_key": "property/6737460151192620/019e1e08-4b22-75ac-8509-be89e9a7a52e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Zx35xK5QYYRgJwmPhDQTCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_8c4cccc7-f04c-4671-bb28-75ff276b6cf4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Fit For Life Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "2200 Avenue F Corner of Highway 60/Ave F and, 6th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-9c6b-74fe-9301-0391b8d23445.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e05-9c6b-74fe-9301-0391b8d23445",
        "storage_key": "property/6737460151192620/019e1e05-9c6b-74fe-9301-0391b8d23445.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://ffl.fitness/",
      "poi_directions_map_url": "https://maps.google.com/?cid=388101350068307028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fit-for-life-gym",
      "poi_latitude": "28.9815673",
      "poi_longitude": "-95.9701778",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-245-5535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU6WX9Ti5QYYRVMSrIx_QYgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5a86cde7-3c16-4c37-a91f-31e8bf330565",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Bay City Chiropractic Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1401 Avenue G, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.chiropracticbaycity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11963778193985238534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-city-chiropractic-center",
      "poi_latitude": "28.9903358",
      "poi_longitude": "-95.9689011",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-245-6844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8KHO0S5QYYRBvYNcOHgB6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_518ac53e-2c8b-4f34-b328-b3915573c19f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "In Motion Chiropractic",
      "poi_type": "Health and Wellness",
      "poi_address": "2814 Nichols Ave, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-3425-7302-8e02-e4fe14530070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-3425-7302-8e02-e4fe14530070",
        "storage_key": "property/6737460151192620/019e1e08-3425-7302-8e02-e4fe14530070.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://inmotionchiropractictx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7051559900976104644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "in-motion-chiropractic",
      "poi_latitude": "28.9754698",
      "poi_longitude": "-95.9535219",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 979-244-4502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dT7BDu5QYYRxMQRgl4s3GE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "custom_c303c69a-9499-4bb9-be1f-d9a32f2abacb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Riverside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7330 FM 2668, Bay City, TX 77414, USA",
      "poi_short_description": "Wooded, clean park that was rebuilt after Hurricane Harvey in 2017. Beach, campgrounds, picnic tables, playgrounds and boat ramps are among its features.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-29ad-76c9-8e16-1808ddc6564d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-29ad-76c9-8e16-1808ddc6564d",
        "storage_key": "property/6737460151192620/019e1e08-29ad-76c9-8e16-1808ddc6564d.webp",
        "width": 1280,
        "height": 863
      },
      "poi_business_url": "https://campriverside.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18143231316689163772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-park",
      "poi_latitude": "28.9205326",
      "poi_longitude": "-96.014034",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 979-245-0340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c070-708d-926d-361531c0301f",
        "storage_key": "property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHRr7H12_QYYR_BUAbcG0yfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_86a72091-8678-4935-a4a5-b1d66acdc904",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Rio Colorado Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7320 FM2668, Bay City, TX 77414, USA",
      "poi_short_description": "Vibrant golf course featuring well-kept facilities, plus wildlife, including alligators.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-a64a-7666-a829-924d02c61601.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e05-a64a-7666-a829-924d02c61601",
        "storage_key": "property/6737460151192620/019e1e05-a64a-7666-a829-924d02c61601.webp",
        "width": 1280,
        "height": 1021
      },
      "poi_business_url": "https://golfriocolorado.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2364079369430702672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rio-colorado-golf-course",
      "poi_latitude": "28.9216267",
      "poi_longitude": "-95.9975604",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-244-2955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c06e-73c7-955b-3441cc938d83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c06e-73c7-955b-3441cc938d83",
        "storage_key": "property/6737460151192620/019e1e05-c06e-73c7-955b-3441cc938d83.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJzTfvXOW4QYYRUBq_O6nlziA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ff8abcca-5dcb-4992-a0ed-3e0df7e383c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Bay Ridge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bay Ridge Park, 1221 Bay Ridge Blvd, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=464013602915139534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-ridge-park",
      "poi_latitude": "28.9555615",
      "poi_longitude": "-95.9736662",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 979-323-1660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c070-708d-926d-361531c0301f",
        "storage_key": "property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3pG7Tu5QYYRzr-01OmBcAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_304b9b97-e07d-41d5-9a6c-e641e445526a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Mary Withers Runnells Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2411 6th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13859552966438259902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mary-withers-runnells-park",
      "poi_latitude": "28.9823938",
      "poi_longitude": "-95.961037",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c070-708d-926d-361531c0301f",
        "storage_key": "property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8_ahW5QYYRvoxD7v0FV8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b7f93fb0-4eb0-4653-a68b-b97a1f743103",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Duncan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Duncan Park, 612 Duncan St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211736952825634175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duncan-park",
      "poi_latitude": "28.9708875",
      "poi_longitude": "-95.982354",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c070-708d-926d-361531c0301f",
        "storage_key": "property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJowo6Zgm5QYYRf92iIJFf3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9bcb921c-bc2a-4060-a5b7-b803829bd432",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Barkway Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1700 Avenue H, Bay City, TX 77414, USA",
      "poi_short_description": "Fenced park featuring agility equipment plus separate areas for large and small dogs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-381e-753a-a497-79eaef7de1a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-381e-753a-a497-79eaef7de1a9",
        "storage_key": "property/6737460151192620/019e1e08-381e-753a-a497-79eaef7de1a9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofbaycity.org/566/Barkway",
      "poi_directions_map_url": "https://maps.google.com/?cid=554828306902355831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barkway-dog-park",
      "poi_latitude": "28.9871296",
      "poi_longitude": "-95.9675818",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c070-708d-926d-361531c0301f",
        "storage_key": "property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWH50Ua5QYYRdw8_0Gclswc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_806b244b-0956-4542-b211-4cebfabc18d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Hardeman Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Hardeman Park, 600 12th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-387b-770e-bb0a-966f50370267.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-387b-770e-bb0a-966f50370267",
        "storage_key": "property/6737460151192620/019e1e08-387b-770e-bb0a-966f50370267.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11542489308583129211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hardeman-park",
      "poi_latitude": "28.9872693",
      "poi_longitude": "-95.9835939",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c070-708d-926d-361531c0301f",
        "storage_key": "property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJreUj1im_QYYRe3DXFd8oL6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0173a3ba-fcc5-4ab7-a921-c8141bfffdc2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Matagorda Bay Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6420 FM Rd 2031, Matagorda, TX 77457, USA",
      "poi_short_description": "Relaxed spot featuring airy campsites plus RV hookups, and a nature center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-29a4-7030-b6c6-6ed83fbe6587.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-29a4-7030-b6c6-6ed83fbe6587",
        "storage_key": "property/6737460151192620/019e1e08-29a4-7030-b6c6-6ed83fbe6587.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://lcraparks.com/parks/matagorda-bay-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13640594996749120648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matagorda-bay-nature-park",
      "poi_latitude": "28.5978718",
      "poi_longitude": "-95.9776639",
      "poi_miles_from_property": "26",
      "poi_walking_minutes": "9 hours 21 mins",
      "poi_biking_minutes": "2 hours 22 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 979-863-2603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c070-708d-926d-361531c0301f",
        "storage_key": "property/6737460151192620/019e1e05-c070-708d-926d-361531c0301f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-CU4J_bQYYRiLQz6uAgTb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_293f30e7-b1ff-465e-a946-4c2ebdbf58c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1400 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-381b-74ff-93e5-28e7fb531445.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-381b-74ff-93e5-28e7fb531445",
        "storage_key": "property/6737460151192620/019e1e08-381b-74ff-93e5-28e7fb531445.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.greyhound.com/bus/bay-city-tx/bay-city-food-mart?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=14157625683351378206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "28.9826405",
      "poi_longitude": "-95.9733647",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxjP8De5QYYRHhkbd4z9ecQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_33ae1bec-223c-4cc0-9304-cdf02870888f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Bay City Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3598 FM 2540, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-3804-750e-86a9-2e35fe664dac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-3804-750e-86a9-2e35fe664dac",
        "storage_key": "property/6737460151192620/019e1e08-3804-750e-86a9-2e35fe664dac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.baycitytx.gov/523/Airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=9912844631885385864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-city-regional-airport",
      "poi_latitude": "28.973516",
      "poi_longitude": "-95.8608114",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 979-244-5037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b5a-722f-a40e-d5802bf10874.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b5a-722f-a40e-d5802bf10874",
        "storage_key": "property/6737460151192620/019e1e08-4b5a-722f-a40e-d5802bf10874.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQVHg3gG3QYYRiJAqFax_kYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_5a6f4b96-bd41-4627-a402-c7489c6bc079",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "MOPAC Train Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "2620 Avenue G, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-9630-73ab-b775-c1a07745290c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e05-9630-73ab-b775-c1a07745290c",
        "storage_key": "property/6737460151192620/019e1e05-9630-73ab-b775-c1a07745290c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.cityofbaycity.org/190/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=8265558821169365013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mopac-train-depot",
      "poi_latitude": "28.9767625",
      "poi_longitude": "-95.9686019",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-323-1660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHV4uP9G5QYYRFYDlffQptXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_71badd7a-70ef-4a7f-aa73-cede91f212f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Port of Bay City",
      "poi_type": "Transportation & Transit",
      "poi_address": "Farm-To-Market 3057, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.portofbaycity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7043116398599394571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-of-bay-city",
      "poi_latitude": "28.9830954",
      "poi_longitude": "-95.9745157",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-245-5831",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b4f-777b-a0fa-7db3150a2215.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b4f-777b-a0fa-7db3150a2215",
        "storage_key": "property/6737460151192620/019e1e08-4b4f-777b-a0fa-7db3150a2215.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28rqsqrBQYYRC9U-agwtvmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_9d74fa06-c7eb-4a95-be25-99b12dd1e710",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Matagorda Regional Medical Center Heliport",
      "poi_type": "Transportation & Transit",
      "poi_address": "104 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-3ba0-777b-bac3-3ffb19f81329.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-3ba0-777b-bac3-3ffb19f81329",
        "storage_key": "property/6737460151192620/019e1e08-3ba0-777b-bac3-3ffb19f81329.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://rymaps.xyz/business/matagorda-regional-medical-center-heliport-lcrqnz",
      "poi_directions_map_url": "https://maps.google.com/?cid=11935975681802178112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matagorda-regional-medical-center-heliport",
      "poi_latitude": "28.9798796",
      "poi_longitude": "-95.9923067",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-245-6383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b5a-722f-a40e-d5802bf10874.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b5a-722f-a40e-d5802bf10874",
        "storage_key": "property/6737460151192620/019e1e08-4b5a-722f-a40e-d5802bf10874.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJXXC-Fli_QYYRQA6FoaQapaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "heliport"
    },
    {
      "id": "custom_1bfd20fd-b87a-4802-8b21-7ac5bcc09e53",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Fairfield by Marriott Inn & Suites Bay City",
      "poi_type": "Transportation & Transit",
      "poi_address": "515 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "Cozy rooms & suites in a straightforward hotel with an outdoor pool & a bar, plus free breakfast.",
      "poi_long_description": "Cozy rooms & suites in a straightforward hotel with an outdoor pool & a bar, plus free breakfast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-380f-75f8-9f31-269987c69333.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-380f-75f8-9f31-269987c69333",
        "storage_key": "property/6737460151192620/019e1e08-380f-75f8-9f31-269987c69333.webp",
        "width": 569,
        "height": 320
      },
      "poi_business_url": "https://www.marriott.com/en-us/hotels/bbcfi-fairfield-inn-and-suites-bay-city/overview/?scid=f2ae0541-1279-4f24-b197-a979c79310b0",
      "poi_directions_map_url": "https://maps.google.com/?cid=2885225662911581768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairfield-by-marriott-inn--suites-bay-city",
      "poi_latitude": "28.982689",
      "poi_longitude": "-95.984944",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-323-9191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b4c-7662-954d-0531960c545e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b4c-7662-954d-0531960c545e",
        "storage_key": "property/6737460151192620/019e1e08-4b4c-7662-954d-0531960c545e.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJMQMhgcq-QYYRSI6vLnRhCig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_445dedbf-9445-4483-bb22-cc9111591201",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Matagorda Regional Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "104 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-a3c7-757a-83e7-6a0b91375e80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e05-a3c7-757a-83e7-6a0b91375e80",
        "storage_key": "property/6737460151192620/019e1e05-a3c7-757a-83e7-6a0b91375e80.webp",
        "width": 1200,
        "height": 630
      },
      "poi_business_url": "http://www.matagordaregional.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17960883350460533214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matagorda-regional-medical-center",
      "poi_latitude": "28.980978",
      "poi_longitude": "-95.9927189",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-245-6383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00e-74d3-afad-7a5d8f470e3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00e-74d3-afad-7a5d8f470e3d",
        "storage_key": "property/6737460151192620/019e1e05-c00e-74d3-afad-7a5d8f470e3d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ4b_UMi-QYYR3oltFD_gQfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_366dd6dc-c808-4ebb-a4fa-b5fe03aeb714",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Matagorda County District Clerk’s Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1700 7th St #307, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-441f-7073-85b3-0960dd2c1a8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-441f-7073-85b3-0960dd2c1a8a",
        "storage_key": "property/6737460151192620/019e1e08-441f-7073-85b3-0960dd2c1a8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.co.matagorda.tx.us/page/matagorda.District.Clerk",
      "poi_directions_map_url": "https://maps.google.com/?cid=6946051344285920722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matagorda-county-district-clerks-office",
      "poi_latitude": "28.9824041",
      "poi_longitude": "-95.9694965",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-244-7621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b4f-777b-a0fa-7db3150a2215.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b4f-777b-a0fa-7db3150a2215",
        "storage_key": "property/6737460151192620/019e1e08-4b4f-777b-a0fa-7db3150a2215.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRSdhzi5QYYR0m3JV-VUZWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_bbc994d1-88c1-46fe-881d-8ce787ccdeac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "City of Bay City - City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1901 5th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6785713723152925557&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-bay-city---city-hall",
      "poi_latitude": "28.9810984",
      "poi_longitude": "-95.9673606",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-245-2137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b4f-777b-a0fa-7db3150a2215.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b4f-777b-a0fa-7db3150a2215",
        "storage_key": "property/6737460151192620/019e1e08-4b4f-777b-a0fa-7db3150a2215.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95go1Ti5QYYRdQMG0K2yK14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_6817d465-bd89-47c0-ba70-80f755677ba5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Bay City ISD Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "520 7th St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.bcblackcats.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11122212405873691892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-city-isd-administration-building",
      "poi_latitude": "28.981957",
      "poi_longitude": "-95.9836045",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-401-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c05b-706c-bb88-93fb51799d47",
        "storage_key": "property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF8Ucscq-QYYR9EyLUEEJWpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ab5f9212-6b10-4171-913c-c07ae37f10e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Tenaris Bay City",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7960 TX-35, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-3dfc-745a-adde-62fc8ecc224e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-3dfc-745a-adde-62fc8ecc224e",
        "storage_key": "property/6737460151192620/019e1e08-3dfc-745a-adde-62fc8ecc224e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tenaris.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2883252568679765145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tenaris-bay-city",
      "poi_latitude": "29.0100509",
      "poi_longitude": "-95.897372",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9Yxc0v-5QYYRmdTjYe9eAyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_17bf4c53-51c1-47ea-9bca-c320b76fd30b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Celanese, Bay City TX",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Second St, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-3f77-720e-a582-3c9d8249317c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-3f77-720e-a582-3c9d8249317c",
        "storage_key": "property/6737460151192620/019e1e08-3f77-720e-a582-3c9d8249317c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5956332028399771623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "celanese-bay-city-tx",
      "poi_latitude": "28.8610494",
      "poi_longitude": "-96.0214945",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 979-241-4001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC5DOlHPBQYYR598M_WskqVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_b11b3490-264c-47b2-8dab-7eb3f1e8a595",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "OXEA Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2001 Farm-To-Market 3057, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-40f1-7309-b70a-6a0b2843200f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e08-40f1-7309-b70a-6a0b2843200f",
        "storage_key": "property/6737460151192620/019e1e08-40f1-7309-b70a-6a0b2843200f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11270207662169509793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxea-corporation",
      "poi_latitude": "28.8630178",
      "poi_longitude": "-96.0200347",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 979-241-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c00f-74d7-a446-33842736c896",
        "storage_key": "property/6737460151192620/019e1e05-c00f-74d7-a446-33842736c896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65jLf-HAQYYRoc9_GCjSZ5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_2abc2dae-3203-4478-bb06-ea8e01abf1ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Wharton County Junior College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4000 Avenue F B, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-8a79-70a4-8501-2b72c23d933b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e05-8a79-70a4-8501-2b72c23d933b",
        "storage_key": "property/6737460151192620/019e1e05-8a79-70a4-8501-2b72c23d933b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.wcjc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=633489784645021473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wharton-county-junior-college",
      "poi_latitude": "28.9627333",
      "poi_longitude": "-95.9713257",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 979-532-4560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e05-c05b-706c-bb88-93fb51799d47",
        "storage_key": "property/6737460151192620/019e1e05-c05b-706c-bb88-93fb51799d47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmfNusSe5QYYRIe-aTpqbygg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8bf4af73-b31c-4800-a7db-6ada5910fb40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "poi_name": "Matagorda County Sheriff’s Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2308 Avenue F, Bay City, TX 77414, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.co.matagorda.tx.us/page/matagorda.Sheriff",
      "poi_directions_map_url": "https://maps.google.com/?cid=12299602261998398011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matagorda-county-sheriffs-office",
      "poi_latitude": "28.9800517",
      "poi_longitude": "-95.9703481",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-245-5526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e1e08-4b4f-777b-a0fa-7db3150a2215.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e08-4b4f-777b-a0fa-7db3150a2215",
        "storage_key": "property/6737460151192620/019e1e08-4b4f-777b-a0fa-7db3150a2215.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YvRqDm5QYYRO2oBWRf3sKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_677755ad-f492-4424-bd0a-e3545e74227e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_eb6ce4dc-19e0-4c22-8ab1-5d0980acc0c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e84229c8-e832-4f89-a099-424c3711ab4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3f6ae02e-cba2-4a51-8939-82f037c3ccab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3ea2bcc4-3139-4d37-87ac-e6657647bd12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_6d6353f1-f74a-4fa5-857c-000302f469aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "rating": "5",
      "name": "Frank James",
      "text": "Working with Ms Pat has been a pleasurable experience. From day one, Ms Pat was warm, welcoming, knowledgeable and very considerate of what I had in mind for my next place of residence. I am both grateful and appreciative of the efforts put forth and lengths Ms Pat went to secure my residence Thanks is an understatement!",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_907fd5c3-2973-48d0-af92-d8fc099f7584",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "rating": "5",
      "name": " D Howard",
      "text": "Ms. Patricia was very helpful with our application and move in process. She didn't mind all of my calls before we moved in. Ms. Lois was also very helpful. We had a few issues but maintenance responded promptly to our requests. We are enjoying the peace and quiet of the Meadow Chase community.",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_5073c548-7820-4a7c-9b40-969b52448250",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "rating": "5",
      "name": "Chloe Marsden",
      "text": "Amazing service, quick on their feet",
      "date": "2026-04-03",
      "title": "false"
    },
    {
      "id": "custom_56eb4279-e0b8-4eac-a7d4-c4f33cc60b34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "rating": "5",
      "name": "Kathy Holton",
      "text": "Gerald showed up right away and fixed my issue right away.",
      "date": "2026-05-01",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_38f14ce1-6d80-4825-a557-e2e340487e2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019e4c24-f42c-76fc-aedc-a095834ab128.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4c24-f42c-76fc-aedc-a095834ab128",
        "storage_key": "property/6737460151192620/019e4c24-f42c-76fc-aedc-a095834ab128.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Exterior",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=68b8a579da10e3bde06b6871"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e69-0c29-760c-a611-9f1edb2cb1bf",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-meadow-chase-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620"
    },
    {
      "lead_collector_id": "019a5025-2841-725d-b022-0ceddc706ce8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-meadow-chase-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "page_item_url": "pool-apartments-bay-city-tx-meadow-chase",
      "search_query": "pool apartments in Bay City TX",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Bay City, TX",
      "h2_subtitle": "Dive into comfort at our pool apartments in Bay City, TX. Meadow Chase offers a refreshing swimming oasis and a range of modern amenities.",
      "page_copy": "Discover your new home at Meadow Chase, where poolside living meets convenience in Bay City, TX. Our apartment community provides a sparkling pool, perfect for relaxation and sunny days. With floor plans featuring spacious studio, stylish one-bedroom, and comfortable two-bedroom options, you can select the ideal layout for your needs. Make the most of modern amenities like ceiling fans, a business center, and on-site management.\n\nLocated in the vibrant Texas South Area, Meadow Chase is more than just a home. Here, you'll enjoy an enriched lifestyle with planned social activities and a welcoming community. Whether you're looking to dive into the pool, relax on the patio, or partake in our community events, Meadow Chase is ready to welcome you. Reach out to schedule a tour or check availability today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table under a teal umbrella.",
        "public_id": "019d0783-d369-75c8-a09d-943542d91fe6",
        "storage_key": "property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
        "width": 1236,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Bay City, TX",
      "seo_description": "Meadow Chase offers pool apartments in Bay City, TX with spacious living and modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-texas-south-area-meadow-chase",
      "search_query": "air conditioned apartments Texas South Area",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Texas South Area",
      "h2_subtitle": "Stay cool in air conditioned apartments in the Texas South Area. Meadow Chase offers comfortable living with top-notch amenities.",
      "page_copy": "Escape the heat and enjoy comfortable living at Meadow Chase, where our air conditioned apartments in the Texas South Area provide the perfect haven from warm Texas days. Each home features essential cooling systems to ensure a pleasant atmosphere all year round. Choose from our studio, one-bedroom, or two-bedroom floor plans to find the perfect fit for your lifestyle needs.\n\nBeyond climate comfort, Meadow Chase in Bay City, TX, gifts residents with an array of modern conveniences such as gated access, patio spaces, and planned social activities. Our on-site management team is dedicated to ensuring you have the best living experience possible. Whether you're lounging by the pool or enjoying the vibrant community, Meadow Chase is your go-to destination for a cool and enjoyable lifestyle. Contact us today to find out more or schedule a tour!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table under a teal umbrella.",
        "public_id": "019d0783-d369-75c8-a09d-943542d91fe6",
        "storage_key": "property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
        "width": 1236,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Texas South Area",
      "seo_description": "Find air conditioned apartments in the Texas South Area at Meadow Chase. Enjoy cool living with excellent amenities. Learn more today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-bay-city-tx-meadow-chase",
      "search_query": "apartments with dishwasher Bay City TX",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Bay City, TX",
      "h2_subtitle": "Explore our apartments with a dishwasher in Bay City, TX. Meadow Chase offers modern conveniences and spacious living options.",
      "page_copy": "At Meadow Chase, we understand the importance of modern kitchen conveniences, which is why our Bay City, TX apartments come equipped with dishwashers. Save time and enjoy more of life with this essential feature in all our floor plans, including spacious studios, chic one-bedroom, and inviting two-bedroom layouts.\n\nLocated in the welcoming Texas South Area, Meadow Chase provides more than just convenient kitchen amenities. Our residents enjoy a gated community with a refreshing pool, ceiling fans, and a vibrant social scene. Perfectly positioned in Bay City, TX, Meadow Chase offers both convenience and community. Ready to upgrade your lifestyle? Schedule a tour today or check our available apartments now!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table under a teal umbrella.",
        "public_id": "019d0783-d369-75c8-a09d-943542d91fe6",
        "storage_key": "property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
        "width": 1236,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Bay City, TX",
      "seo_description": "Discover apartments with a dishwasher at Meadow Chase in Bay City, TX. Enjoy modern living with a range of amenities. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "page_item_url": "on-site-management-apartments-matagorda-county-meadow-chase",
      "search_query": "on-site management apartments in Matagorda County",
      "category": "Amenity",
      "h1_title": "On-Site Management Apartments in Matagorda County",
      "h2_subtitle": "Experience peace of mind with on-site management at Meadow Chase. Our Matagorda County apartments ensure attentive service and modern amenities.",
      "page_copy": "Meadow Chase in Bay City, TX, offers the assurance of on-site management, providing residents in Matagorda County with prompt and attentive service. Our dedicated team is available to address needs and ensure seamless living in our spacious studio, one-bedroom, and two-bedroom apartments.\n\nBeyond management support, our community features essential amenities such as a swimming pool, planned social activities, and modern conveniences like dishwashers and ceiling fans. Nestled in the Texas South Area, Meadow Chase combines personalized management with an enriched living experience. Discover the reliability of on-site support and a vibrant community by scheduling a visit or exploring our availability today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table under a teal umbrella.",
        "public_id": "019d0783-d369-75c8-a09d-943542d91fe6",
        "storage_key": "property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
        "width": 1236,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "On-Site Management Apartments Matagorda County",
      "seo_description": "Find on-site management apartments in Matagorda County at Meadow Chase. Enjoy attentive service and modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "page_item_url": "high-speed-internet-access-apartments-77414-meadow-chase",
      "search_query": "high speed internet access apartments 77414",
      "category": "Amenity",
      "h1_title": "High-Speed Internet Access Apartments 77414",
      "h2_subtitle": "Stay connected with high-speed internet access at Meadow Chase. Our apartments in the 77414 area offer seamless connectivity for all your needs.",
      "page_copy": "In the heart of Bay City, TX, Meadow Chase provides high-speed internet access in all our apartments, ensuring you're always connected to what matters most. Whether you're streaming movies, working from home, or browsing the web, our fast internet service in the 77414 area has you covered.\n\nOffering comfortable studio, one-bedroom, and two-bedroom options, Meadow Chase pairs modern connectivity with enviable amenities like a refreshing pool, gated access, and inviting patios. Located within Matagorda County's vibrant Texas South Area, our community promises convenience and modern living. Schedule a tour today to discover why Meadow Chase is the perfect place to call home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table under a teal umbrella.",
        "public_id": "019d0783-d369-75c8-a09d-943542d91fe6",
        "storage_key": "property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
        "width": 1236,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High-Speed Internet Access Apartments 77414",
      "seo_description": "Discover high-speed internet access apartments in the 77414 area at Meadow Chase. Enjoy seamless connectivity and modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-bay-city-tx-meadow-chase",
      "search_query": "one bedroom apartments bay city tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Bay City, TX",
      "h2_subtitle": "Discover stylish one-bedroom apartments at Meadow Chase. Enjoy modern living in Bay City, TX, with a variety of amenities.",
      "page_copy": "Meadow Chase offers chic and comfortable one-bedroom apartments in Bay City, TX, tailored to fit your lifestyle needs. Each apartment is thoughtfully designed with contemporary features, including dishwashers and ceiling fans, to enhance your living experience.\n\nSituated in the welcoming Texas South Area, our community provides a host of amenities such as a refreshing pool, planned social activities, and the security of a gated entrance. Whether you're new to the area or a long-time resident, our Bay City apartments offer a blend of convenience and style. Ready to elevate your living experience? Contact us today to explore availability or to schedule a tour.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table under a teal umbrella.",
        "public_id": "019d0783-d369-75c8-a09d-943542d91fe6",
        "storage_key": "property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
        "width": 1236,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Bay City, TX",
      "seo_description": "Explore stylish one-bedroom apartments in Bay City, TX at Meadow Chase. Enjoy modern amenities and a vibrant community. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "page_item_url": "2-bedroom-apartment-matagorda-county-meadow-chase",
      "search_query": "2 bedroom apartment matoagorda county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartment in Matagorda County",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Meadow Chase. Enjoy modern amenities in charming Matagorda County.",
      "page_copy": "Located in Bay City, TX, Meadow Chase offers expansive two-bedroom apartments ideal for families and roommates in Matagorda County. Each apartment is equipped with modern conveniences like dishwashers and ceiling fans, providing a comfortable and hassle-free living experience.\n\nIn addition to ample living space, our community features amenities such as a refreshing pool, gated access, and planned social activities. Set in the beautiful Texas South Area, Meadow Chase guarantees the right balance of privacy and community spirit. Ready to see it for yourself? Schedule a tour today and discover why so many choose to call us home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table under a teal umbrella.",
        "public_id": "019d0783-d369-75c8-a09d-943542d91fe6",
        "storage_key": "property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
        "width": 1236,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartment in Matagorda County",
      "seo_description": "Find your perfect 2 bedroom apartment in Matagorda County at Meadow Chase. Spacious living with modern amenities awaits. Book a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192620",
      "source": "generator",
      "page_item_url": "studio-apt-texas-south-area-meadow-chase",
      "search_query": "studio apt texas south area",
      "category": "Floorplan",
      "h1_title": "Studio Apt in Texas South Area",
      "h2_subtitle": "Discover cozy studio apartments at Meadow Chase in the Texas South Area. Enjoy modern living at an affordable price.",
      "page_copy": "Meadow Chase invites you to explore our charming studio apartments located in the vibrant Texas South Area of Bay City, TX. Perfectly sized for efficiency and comfort, these apartments feature all the essentials, making them a great choice for students and young professionals alike.\n\nBeyond stylish living spaces, our community offers a variety of amenities, including a swimming pool and planned social activities, providing both relaxation and entertainment. With on-site management and a safe, gated environment, Meadow Chase ensures your lifestyle needs are met. Visit us today and see why our studio apartments are the ideal home in Matagorda County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table under a teal umbrella.",
        "public_id": "019d0783-d369-75c8-a09d-943542d91fe6",
        "storage_key": "property/6737460151192620/019d0783-d369-75c8-a09d-943542d91fe6.webp",
        "width": 1236,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apt in Texas South Area",
      "seo_description": "Explore studio apartments in the Texas South Area at Meadow Chase. Enjoy cozy living with modern amenities. Visit us in Bay City, TX today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3371"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483485"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4606442"
    },
    {
      "ID": "custom_best_of_logo",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T97F4C66"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "979-426-7990"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "979-243-6814"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "979-310-5428"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "979-432-7457"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "979-553-7066"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "979-475-7939"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "979-451-6721"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "979-316-9517"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "979-451-6903"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "979-325-3516"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "979-559-3884"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "979-406-6504"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "979-310-5934"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "979-701-2689"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "979-658-8048"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "979-366-3352"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "979-475-9212"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "979-202-4497"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321288551"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "979-553-7030"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "979-657-6788"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "1ea816cf11ee9cfd"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "979-432-7712"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "979-406-5202"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "979-476-7684"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "979-316-8636"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "979-451-6741"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "979-310-4413"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "979-310-4358"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.meadowchasebaycity.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192620/019e60fe-c2d5-73ef-a99e-bbbe08554b9b.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "979-356-3589"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "979-325-3516"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3371",
  "custom_repli_id": "5028483485",
  "custom_realpage_id": "4606442",
  "custom_best_of_logo": "true",
  "custom_knock_a_link": "https://www.meadowchasebaycity.com?utm_knock=a",
  "custom_knock_g_link": "https://www.meadowchasebaycity.com?utm_knock=g",
  "custom_knock_r_link": "https://www.meadowchasebaycity.com?utm_knock=r",
  "custom_knock_w_link": "https://www.meadowchasebaycity.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-T97F4C66",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.meadowchasebaycity.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.meadowchasebaycity.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.meadowchasebaycity.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.meadowchasebaycity.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.meadowchasebaycity.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.meadowchasebaycity.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "979-426-7990",
  "custom_knock_ads_link": "https://www.meadowchasebaycity.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.meadowchasebaycity.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "979-243-6814",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.meadowchasebaycity.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.meadowchasebaycity.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.meadowchasebaycity.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.meadowchasebaycity.com?utm_knock=psa",
  "custom_knock_r_number": "979-310-5428",
  "custom_knock_w_number": "979-432-7457",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "979-553-7066",
  "custom_knock_amap_link": "https://www.meadowchasebaycity.com?utm_knock=amap",
  "custom_knock_ar_number": "979-475-7939",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "979-451-6721",
  "custom_knock_fb_number": "979-316-9517",
  "custom_knock_fl_number": "979-451-6903",
  "custom_knock_gp_number": "979-325-3516",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.meadowchasebaycity.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "979-559-3884",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.meadowchasebaycity.com?utm_knock=bcard",
  "custom_knock_bnr_number": "979-406-6504",
  "custom_knock_cfres_link": "https://www.meadowchasebaycity.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "979-310-5934",
  "custom_knock_lgp_number": "979-701-2689",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.meadowchasebaycity.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "979-658-8048",
  "custom_knock_psa_number": "979-366-3352",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "979-475-9212",
  "custom_knock_bandit_link": "https://www.meadowchasebaycity.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.meadowchasebaycity.com?utm_knock=flyers",
  "custom_knock_osoc_number": "979-202-4497",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321288551",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "979-553-7030",
  "custom_knock_cfres_number": "979-657-6788",
  "custom_knock_chatgpt_link": "https://www.meadowchasebaycity.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "1ea816cf11ee9cfd",
  "custom_knock_dirmail_link": "https://www.meadowchasebaycity.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "979-432-7712",
  "custom_knock_propbro_link": "https://www.meadowchasebaycity.com?utm_knock=propbro",
  "custom_knock_bandit_number": "979-406-5202",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "979-476-7684",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.meadowchasebaycity.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "979-316-8636",
  "custom_knock_dirmail_number": "979-451-6741",
  "custom_knock_propbro_number": "979-310-4413",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "979-310-4358",
  "custom_knock_maintenance_link": "https://www.meadowchasebaycity.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192620/019e60fe-c2d5-73ef-a99e-bbbe08554b9b.mp4",
  "custom_knock_maintenance_number": "979-356-3589",
  "custom_ppc_tracking_phone_number": "979-325-3516"
};

export const generatedAt = '2026-10-07T17:14:42.106Z';
